export default __webpack_public_path__ + "static/logo-white-7dc9690cdfe4888e5e6295db867f6127.png";